import { PropsWithChildren, useEffect } from 'react'
import { useRouter } from 'next/router'

import LayoutController from '@/components/layout/controller'
import Footer from '@/components/layout/footer'
import LeadGeneration from '@/components/layout/lead-generation'
import LeadGenerationProductForm from '@/components/layout/lead-generation-product-form'
import { LenisProvider } from '@/contexts/lenis'
import { useLocaleStore } from '@/store/locale'
import { useRouterStore } from '@/store/router'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageProps: WPPageData }>

const Layout = ({ children, pageProps }: LayoutProps) => {
  const router = useRouter()
  const setCurrentLocale = useLocaleStore((state) => state.setCurrentLocale)
  const setCurrentRoute = useRouterStore((state) => state.setCurrentRoute)
  const setCurrentTranslations = useLocaleStore(
    (store) => store.setCurrentTranslations
  )

  useEffect(() => {
    setCurrentRoute(router.asPath)
    setCurrentLocale(router.locale)
    setCurrentTranslations(pageProps.wpml_translations || [])
  }, [
    router,
    pageProps.wpml_translations,
    setCurrentRoute,
    setCurrentLocale,
    setCurrentTranslations
  ])

  return (
    <LenisProvider>
      <LayoutController pageProps={pageProps} />
      <div className="static">{children}</div>
      {pageProps.acf?.show_form ? <LeadGenerationProductForm /> : null}
      <LeadGeneration showTopFluidSpacer={!pageProps.acf?.show_form} />
      <Footer />
    </LenisProvider>
  )
}

export default Layout
